function validaCel(val) {
  let celular = val.replace(/\s/g, '');
  let digito = celular.substr(4, 1);

  if(!val)
    return true;

  let len = val.toString().replace(/[^0-9]/g, '').length;

  if (len == 11 && digito == "9" ) {
      return true;
  } else if (len == 10 && (digito == "6" || digito == "7" || digito == "8" || digito == "9")) {
      return true;
  }
  return false;
}


export default {
  messages: {
    en: (field, args) => {
      return "Celular inválido";
    },
    'pt-BR': (field, args) => {
      return "Celular inválido";
    }
  },
  validate(value) {
    return validaCel(value);
  }
};



// WEBPACK FOOTER //
// ./src/validators/cell.js